import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  IconButton,
  Button,
  Typography,
  FormControl,
  FormControlLabel,
} from '@material-ui/core'
import { Field, Form } from 'react-final-form'
import IconBack from '@material-ui/icons/ArrowBack'
import { Checkbox } from 'components/common/FormInputs'
import withPromise from 'helpers/withPromise'
import Input from 'components/common/Form/Input'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import {
  locusFetchFormData,
  locusChange,
  locusClearStateForm,
} from 'reducers/locus/reducer'
import { REACT_INTL_PROP_TYPE } from 'constants/propTypes'
import DependentSelectLists from './DependentSelectLists'
import messages from './translate'

class LocusItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
    }
  }

  componentDidMount() {
    const { locusFetchFormData } = this.props

    locusFetchFormData({
      entityId: this.getEntityId(),
    })
  }

  componentDidUpdate() {
    const {
      history: { goBack },
    } = this.props
    const { redirect } = this.state

    if (redirect) {
      goBack()
    }
  }

  componentWillUnmount() {
    const { locusClearStateForm } = this.props

    locusClearStateForm()
  }

  getEntityId() {
    const {
      match: {
        params: { id },
      },
    } = this.props

    return id !== 'create' ? id : false
  }

  onSubmit = values => {
    const { locusChange } = this.props

    return withPromise(locusChange, {
      entityId: this.getEntityId(),
      values: {
        ...values,
      },
    }).then(errors =>
      errors ? Promise.resolve(errors) : this.setState({ redirect: true }),
    )
  }

  render() {
    const {
      intl: { formatMessage },
      history: { goBack },
      formData: data,
    } = this.props
    const formData = data.toJS()
    let locusData = {
      containerName: null,
      site: '',
      locusGroups: [],
      active: true,
      visibleInUi: true,
    }

    if (formData.locus) {
      const {
        containerName,
        site,
        locusGroups,
        active,
        visibleInUi,
      } = formData.locus
      locusData = {
        containerName,
        site: site.id,
        locusGroups: locusGroups.map(item => item.id),
        active,
        visibleInUi,
      }
    }

    return (
      <div className="container-fluid no-breadcrumb">
        <Typography variant="h5" className="headline">
          <IconButton size="medium" className="btn-back" onClick={goBack}>
            <IconBack fontSize="small" />
          </IconButton>
          {formatMessage(messages.locusInfo)}
        </Typography>
        <Form
          onSubmit={this.onSubmit}
          initialValues={locusData}
          mutators={{
            setSite: ([value], state, { changeValue }) => {
              changeValue(state, 'site', () => value)
            },
            setLocusGroups: ([value], state, { changeValue }) => {
              changeValue(state, 'locusGroups', () => value)
            },
          }}
          render={({
            handleSubmit,
            submitting,
            pristine,
            values,
            submitFailed,
            errors,
            form: { mutators },
          }) => (
            <form onSubmit={handleSubmit} className="form-basic">
              <Field
                required
                name="containerName"
                type="text"
                label={formatMessage(messages.name)}
                component={Input}
                disabled={submitting}
                validate={getValidator(VALIDATOR_IS_EMPTY)}
              />
              <Field
                required
                name="site"
                type="hidden"
                validate={getValidator(VALIDATOR_IS_EMPTY)}
                component={() => null}
              />
              <Field name="locusGroups" type="hidden" component={() => null} />
              <DependentSelectLists
                siteList={formData.sites}
                siteValue={values.site}
                siteError={submitFailed && (errors.site || null)}
                setSite={mutators.setSite}
                locusGroupsValue={values.locusGroups}
                locusGroupsError={submitFailed && (errors.locusGroups || null)}
                setLocusGroups={mutators.setLocusGroups}
              />
              <FormControl fullWidth component="div" className="form-group">
                <FormControlLabel
                  label={formatMessage(messages.active)}
                  disabled={submitting}
                  className="form-group"
                  control={
                    <Field
                      name="active"
                      component={Checkbox}
                      type="checkbox"
                      color="primary"
                    />
                  }
                />
                <FormControlLabel
                  label={formatMessage(messages.visibleInUi)}
                  disabled={submitting}
                  className="form-group"
                  control={
                    <Field
                      name="visibleInUi"
                      component={Checkbox}
                      type="checkbox"
                      color="primary"
                    />
                  }
                />
              </FormControl>
              <div className="form-group buttons">
                <Button
                  href={null}
                  type="submit"
                  color="primary"
                  size="medium"
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={submitting || pristine}>
                  {formatMessage(messages.saveInfo)}
                </Button>
              </div>
            </form>
          )}
        />
      </div>
    )
  }
}

LocusItem.propTypes = {
  formData: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  intl: REACT_INTL_PROP_TYPE.isRequired,
  locusFetchFormData: PropTypes.func,
  locusClearStateForm: PropTypes.func,
  locusChange: PropTypes.func,
}

LocusItem.defaultProps = {
  locusFetchFormData: () => {},
  locusClearStateForm: () => {},
  locusChange: () => {},
}

export default connect(
  state => ({
    formData: state.getIn(['locus', 'formData']),
  }),
  {
    locusFetchFormData,
    locusClearStateForm,
    locusChange,
  },
)(injectIntl(LocusItem))
